import React from "react";
import "./SearchItem.scss"
import placeholder from "../../../assets/collections/empty.jpg"

const SearchItem = ({ item, onClick }) => {
    return (
        <div className="SearchItem" onClick={onClick}>
            <div className="SearchItem-Image">
                <img alt="" src={item?.OnLineImages?.PrimaryImages?.Main ?? placeholder} />
            </div>
            <div className="SearchItem-details">
                <div className="SearchItem-title">{item?.Name}</div>
                <div className="SearchItem-price"> £{(item?.SellingPricesArray?.SellingPrice).toFixed(2)}</div>
            </div>
        </div>
    )
}
export default SearchItem